'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import { connect } from 'react-redux';
// import * as authActions from 'redux/modules/auth';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _exu2x = require('assets/img/account/exu@2x.png');

var _exu2x2 = _interopRequireDefault(_exu2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BottomInfoUser = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BottomInfoUser, _Component);

  function BottomInfoUser() {
    (0, _classCallCheck3.default)(this, BottomInfoUser);
    return (0, _possibleConstructorReturn3.default)(this, (BottomInfoUser.__proto__ || (0, _getPrototypeOf2.default)(BottomInfoUser)).apply(this, arguments));
  }

  (0, _createClass3.default)(BottomInfoUser, [{
    key: 'render',
    value: function render() {
      var styles = require('./BottomInfoUser.scss');
      var data = this.props.data;

      return _react2.default.createElement(
        'div',
        { className: styles.bottomBar },
        _react2.default.createElement(
          'div',
          { className: styles.viewInside },
          _react2.default.createElement('img', { src: data.imageRank, className: styles.starBottom }),
          _react2.default.createElement(
            'div',
            { className: styles.textBottom, style: { color: data.color } },
            'H\u1EA0NG ' + data.label.toUpperCase()
          ),
          _react2.default.createElement('div', { style: { flex: 1 } }),
          _react2.default.createElement(
            'div',
            { className: styles.pointView },
            _react2.default.createElement(
              'div',
              { className: styles.pointText },
              '\u0110i\u1EC3m t\xEDch l\u0169y'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pointExu },
              _react2.default.createElement(
                'div',
                { className: styles.point },
                data.pointReward,
                ' '
              ),
              _react2.default.createElement('img', { src: _exu2x2.default, className: styles.exuPoint })
            )
          )
        )
      );
    }
  }]);
  return BottomInfoUser;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object
}, _temp);
exports.default = BottomInfoUser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/BottomInfoUser.js
// module id = 720
// module chunks = 0